
class Loader {

  setActive (withoutBackdrop) {

    const loader = this.getLoader();
    if ( withoutBackdrop ) {

      loader.classList.add('is-transparent');
    }

    loader.classList.add('is-active');
  }

  setInactive (withoutBackdrop) {

    const loader = this.getLoader();
    loader.classList.remove('is-active');

    if ( withoutBackdrop ) {

      loader.classList.remove('is-transparent');
    }
  }

  getLoader() {

    if (!this.el) {

      this.el = document.querySelector('.tc-loader');
    }
    return this.el;
  }
}

export default new Loader();
